import { Snackbar } from "@mui/material";
import { useState } from "react";

import { handleCopyClick as copyAndAlert } from "@/pages/Private/pages/List/utils/handleCopyClick";

export const useCopyToClipboard = () => {
	const [openAlert, setOpenAlert] = useState(false);

	// The snackbar opens only when the browser took the text (PREC-4394).
	const handleCopyClick = (text: string) => copyAndAlert(text, setOpenAlert);

	const renderSnackbar = () => {
		return (
			<Snackbar
				autoHideDuration={2000}
				message="Copied to clipboard"
				open={openAlert}
				onClose={() => setOpenAlert(false)}
			/>
		);
	};

	return { handleCopyClick, renderSnackbar };
};
